/* Ability Warehouse — "Ask about this product": answers only from the product's spec data (WizardData JSON); everything else goes to a person */
(function () {
  'use strict';
  var wiz = document.querySelector('[data-wizard]');
  var dataEl = document.getElementById('WizardData');
  if (!wiz || !dataEl) return;
  var D;
  try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var pdpRoot = document.querySelector('[data-pdp]');
  var noSale = !!(pdpRoot && pdpRoot.dataset.noSale === 'true');
  var panel = wiz.querySelector('.wiz__panel');
  var log = wiz.querySelector('[data-wiz-log]');
  var chipsEl = wiz.querySelector('[data-wiz-chips]');
  var input = wiz.querySelector('[data-wiz-input]');
  var opener = wiz.querySelector('[data-wiz-open]');
  var greeted = false;
  var money = function (c) { return new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' }).format(c / 100); };
  var esc = function (s) { return String(s).replace(/[&<>"']/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]; }); };
  var has = function (v) { return v && v !== 'N/A' && v !== '-'; };
  var title = '<strong>' + esc(D.title) + '</strong>';
  var mq = window.matchMedia('(max-width: 989px)');

  var STARTERS = ['What is the weight rating?', 'How wide is it?', 'Can I use NDIS or DVA funding?', 'Seat height?', 'Does it fit my space?', 'How much is it?'];
  var PLACES = [
    ['shower', /shower|wet ?area|bathroom|bath\b/],
    ['toilet', /toilet|commode|loo\b/],
    ['bed', /\bbed|bedroom|mattress/],
    ['outdoor', /outdoor|outside|footpath|shops|street|uneven/],
    ['car', /\bcar\b|boot|travel|fold/],
    ['stairs', /stair|steps/]
  ];

  /* ---------- helpers ---------- */
  function contact(lead) {
    var tel = D.phone ? D.phone.replace(/[^\d+]/g, '').replace(/^0/, '+61') : '';
    var subj = encodeURIComponent('Question about ' + D.title);
    return (lead ? '<p>' + lead + '</p>' : '') +
      '<div class="wiz__contact"><a class="wiz__cbtn wiz__cbtn--web" href="' + D.contact + '?product=' + encodeURIComponent(D.title) + '">Contact form</a>' +
      (D.email ? '<a class="wiz__cbtn wiz__cbtn--mail" href="mailto:' + esc(D.email) + '?subject=' + subj + '">Email us</a>' : '') +
      (tel ? '<a class="wiz__cbtn wiz__cbtn--tel" href="tel:' + tel + '">Call ' + esc(D.phone) + '</a>' : '') + '</div>';
  }
  function missing(what) { return contact('This product\'s spec sheet doesn\'t list ' + what + ', so I can\'t answer that one. Our team can tell you:'); }
  function say(html, who) {
    var m = document.createElement('div');
    m.className = 'wiz__msg wiz__msg--' + (who || 'bot');
    m.innerHTML = html;
    log.appendChild(m);
    log.scrollTop = log.scrollHeight;
    return m;
  }
  function chips(list) {
    chipsEl.innerHTML = list.map(function (q) { return '<button type="button" class="wiz__chip" data-q="' + esc(q) + '">' + esc(q) + '</button>'; }).join('');
  }
  function spec(label) {
    var r = new RegExp(label, 'i');
    for (var i = 0; i < (D.specs || []).length; i++) if (r.test(D.specs[i][0])) return D.specs[i];
    return null;
  }
  function specList() {
    var rows = [];
    if (has(D.brand)) rows.push('Brand: <strong>' + esc(D.brand) + '</strong>');
    if (has(D.weight)) rows.push('Weight rating: <strong>' + esc(D.weight) + '</strong>');
    if (has(D.width)) rows.push('Width: <strong>' + esc(D.width) + '</strong>');
    if (has(D.seat)) rows.push('Seat height: <strong>' + esc(D.seat) + '</strong>');
    if (has(D.material)) rows.push('Material: <strong>' + esc(D.material) + '</strong>');
    (D.specs || []).forEach(function (r) { if (r[0] && r[1]) rows.push(esc(r[0]) + ': <strong>' + esc(r[1]) + '</strong>'); });
    return rows;
  }
  function fromDescription(q) {
    if (!D.desc) return '';
    var stop = { the: 1, a: 1, an: 1, is: 1, it: 1, this: 1, can: 1, i: 1, for: 1, of: 1, to: 1, in: 1, and: 1, or: 1, does: 1, do: 1, what: 1, how: 1, be: 1, my: 1, with: 1, on: 1, are: 1, you: 1, use: 1, product: 1 };
    var words = q.toLowerCase().replace(/[^a-z0-9 ]/g, ' ').split(/\s+/).filter(function (w) { return w.length > 2 && !stop[w]; });
    if (!words.length) return '';
    var best = '', bestN = 0;
    (D.desc.match(/[^.!?]+[.!?]*/g) || []).forEach(function (sent) {
      var s = sent.toLowerCase(), n = 0;
      words.forEach(function (w) { if (s.indexOf(w) > -1) n++; });
      if (n > bestN) { bestN = n; best = sent; }
    });
    return bestN >= Math.min(2, words.length) ? best.trim() : '';
  }

  /* ---------- the answers ---------- */
  function answer(q) {
    var t = q.toLowerCase();
    if (/^(hi|hello|hey|g'?day|good (morning|afternoon|evening))\b/.test(t))
      return '<p>Hi! Ask me anything about ' + title + ' — weight rating, width, seat height, material, where it suits, or how funding works.</p>';

    if (/weight|rating|safe working|load|heavy|bariatric|kg|kilo|hold me|hold (a|my)|strong enough/.test(t)) {
      if (!has(D.weight)) return missing('a weight rating');
      var kg = parseFloat(String(D.weight).replace(/[^\d.]/g, ''));
      var ask = t.match(/(\d{2,3})\s*(kg|kilo|kilos|kilograms)?/);
      var out = '<p>The spec sheet lists ' + title + ' with a weight rating of <strong>' + esc(D.weight) + '</strong> — that is the safe working load, the heaviest user it is tested for.</p>';
      if (ask && kg) {
        var user = +ask[1];
        if (user <= kg * 0.9) out += '<p>' + user + ' kg is comfortably within the rating.</p>';
        else if (user <= kg) out += '<p>' + user + ' kg is within the rating but close to the limit — allow for clothing and movement. A heavy-duty or bariatric model may be safer.</p>';
        else out += '<p><strong>' + user + ' kg is over this product\'s rating.</strong> Please look at a heavy-duty or bariatric option instead.</p>' + contact('We can point you to the right one:');
      }
      return out;
    }
    if (/seat height|how high|height of the seat|sit height|seat$|\bseat\b/.test(t) && !/width|wide/.test(t)) {
      if (!has(D.seat)) return missing('a seat height');
      return '<p>' + title + ' has a seat height of <strong>' + esc(D.seat) + '</strong>. A good seat height is about the user\'s lower-leg length (floor to the back of the knee in shoes).</p>';
    }
    if (/\bwid(e|th)\b|how big|dimension|size|fit (through|in|my)|doorway|door|gap|space|measure|length|depth|\bdeep\b|\bhigh\b|height/.test(t)) {
      var rows = [];
      if (has(D.width)) rows.push('Width: <strong>' + esc(D.width) + '</strong>');
      if (has(D.seat)) rows.push('Seat height: <strong>' + esc(D.seat) + '</strong>');
      (D.specs || []).forEach(function (r) { if (/width|depth|height|length|dimension|size|diameter|clearance|folded/i.test(r[0]) && rows.join(' ').indexOf(esc(r[1])) < 0) rows.push(esc(r[0]) + ': <strong>' + esc(r[1]) + '</strong>'); });
      if (!rows.length) return missing('the dimensions');
      var fit = /fit|doorway|door|gap|space/.test(t) ? '<p>Measure the narrowest point it has to pass or sit in and compare it with the width above. The measuring guide in <a href="/pages/tools#measure">Tools</a> walks you through it.</p>' : '';
      return '<p>' + rows.join('<br>') + '</p>' + fit;
    }
    if (/ndis|claim|fund|plan manag|self.?managed|plan.?managed|dva|veteran|gold card|white card|home care|package|support at home|hcp|invoice|receipt/.test(t)) {
      return '<p>Whether ' + title + ' can be funded depends on your plan and goals, so we can\'t say whether it is covered. If you\'re funded, check with your plan manager, support coordinator or funding body before you buy. We are not a registered NDIS provider. We provide a tax invoice listing the item and our ABN that you can submit. DVA items usually need a prescriber (GP, OT or physio).</p><p><a href="/pages/funding">Read the funding guide</a>.</p>';
    }
    if (/price|cost|how much|expensive|cheap|\$|discount|sale|deal|member/.test(t)) {
      var o = '<p>' + title + ' is <strong>' + money(D.price) + '</strong>' + (D.member && !noSale ? ' at your member price' : '') + '.';
      o += '</p>';
      if (!D.member && !noSale) o += '<p>Members pay <strong>' + money(D.memberPrice) + '</strong> (' + D.memberPct + '% off) — <a href="' + D.joinUrl + '">first month free, then $' + D.memberMonthly + '/mo</a>. Member savings never stack with sale prices.</p>';
      if (D.regular > D.price && D.sale && !D.member) o += '<p>That\'s the ' + esc(D.sale) + ' price — regular price ' + money(D.regular) + '. The sale ends ' + esc(D.saleEnd) + '.</p>';
      return o;
    }
    for (var i = 0; i < PLACES.length; i++) {
      if (PLACES[i][1].test(t)) {
        var place = PLACES[i][0];
        if (!has(D.useFor)) return missing('where it can be used');
        var hay = (D.useFor + ' ' + D.title + ' ' + (D.desc || '')).toLowerCase();
        var ok = { shower: /shower|bath|wet/, toilet: /toilet|commode/, bed: /\bbed/, outdoor: /outdoor|outside|all.?terrain|kerb/, car: /car|fold|travel|portable|lightweight/, stairs: /stair|step/ }[place].test(hay);
        return ok ? '<p>Yes — the spec sheet lists ' + title + ' as suitable for <strong>' + esc(D.useFor) + '</strong>.</p>'
          : '<p>The spec sheet lists ' + title + ' as suitable for <strong>' + esc(D.useFor) + '</strong>. It doesn\'t mention ' + place + ' use specifically.</p>' + contact('Please check with us before using it there:');
      }
    }
    if (/where (can|could|should)|suitable|use it|used for|what.?s it for|who is it for|suit/.test(t))
      return has(D.useFor) ? '<p>The spec sheet lists ' + title + ' as suitable for <strong>' + esc(D.useFor) + '</strong>.</p>' : missing('where it can be used');
    if (/deliver|shipping|post|freight|how long|when will|dispatch|arrive/.test(t))
      return '<p>' + (D.delivery ? esc(D.delivery) + '. ' : '') + 'We deliver Australia-wide from partner distribution warehouses, and the delivery fee is quoted before dispatch. Selected partner pharmacies and providers offer pickup where shown at checkout.</p>';
    if (/return|refund|warrant|faulty|broken|change my mind/.test(t))
      return '<p>Unused products in original packaging can be returned within 14 days of delivery with proof of purchase. A 25% restocking fee applies and return postage is at your cost. Hygiene items — incontinence, braces, toileting, personal care — can\'t be returned once opened unless faulty. Faulty goods are covered by the Australian Consumer Law and our warranty at no cost. <a href="/pages/refunds-returns">Returns policy</a>.</p>';
    if (/install|fit it|fitting|fix|screw|drill|mount|wall|rent|landlord|assemble|assembly/.test(t))
      return '<p>Installation is coming soon. Anything screwed to a wall needs the right anchors — studs, masonry or a backing board behind plasterboard — and, if you rent, the landlord\'s OK in writing. <a href="/pages/tools#weight-guide">Read the weight-rating &amp; fixing guide</a>.</p>' + contact('Need a hand? Ask us:');
    if (/colou?r|option|variant|come in|available in|model|other size|bigger|smaller|larger/.test(t)) {
      if (D.options && D.options.length) return D.options.map(function (o) { return '<p><strong>' + esc(o.n) + ':</strong> ' + esc(o.v) + '</p>'; }).join('') + '<p>Pick an option above the price to see its stock.</p>';
      return '<p>' + title + ' comes in one version only.</p>' + contact('Ask us about similar products:');
    }
    if (/material|made of|made from|steel|aluminium|plastic|foam|fabric|rust/.test(t))
      return has(D.material) ? '<p>' + title + ' is made from <strong>' + esc(D.material) + '</strong>.</p>' : missing('the material');
    if (/brand|who makes|manufacturer|made by/.test(t))
      return has(D.brand) ? '<p>' + title + ' is made by <strong>' + esc(D.brand) + '</strong>.</p>' : missing('the brand');
    if (/stock|available|availability|sold out|have it|in store/.test(t))
      return D.available ? '<p>Yes — ' + title + ' is showing <strong>in stock</strong> right now.</p>' + contact('For larger quantities, check with us:')
        : '<p>' + title + ' is currently <strong>sold out</strong>.</p>' + contact('Ask us when it\'s due back:');
    if (/spec|feature|benefit|what does it|tell me about|detail|everything/.test(t)) {
      var rows2 = specList();
      var ben = D.benefits ? D.benefits.split(/\r?\n/).filter(Boolean).map(function (b) { return '<li>' + esc(b.replace(/^[-•]\s*/, '')) + '</li>'; }).join('') : '';
      if (!rows2.length && !ben) return missing('much detail');
      return (ben ? '<ul class="wiz__list">' + ben + '</ul>' : '') + (rows2.length ? '<p>' + rows2.join('<br>') + '</p>' : '');
    }
    var row = spec(t.replace(/[^a-z ]/g, '').trim().split(' ').filter(function (w) { return w.length > 3; })[0] || '§');
    if (row) return '<p>' + esc(row[0]) + ': <strong>' + esc(row[1]) + '</strong></p>';
    var quote = fromDescription(q);
    return quote ? '<p>From the product description:</p><blockquote class="wiz__quote">' + esc(quote) + '</blockquote>'
      : contact('I can only answer from this product\'s spec sheet, and it doesn\'t cover that. Our team can help:');
  }

  /* ---------- chat plumbing ---------- */
  function ask(q) {
    q = String(q || '').trim();
    if (!q) return;
    say(esc(q), 'me');
    var m = say('<span class="wiz__dots"><i></i><i></i><i></i></span>', 'bot');
    setTimeout(function () { m.innerHTML = answer(q); log.scrollTop = log.scrollHeight; }, 350);
    chips(STARTERS.filter(function (s) { return s !== q; }).slice(0, 4));
  }
  function viewport() {
    var vv = window.visualViewport;
    if (!vv || !mq.matches || panel.hidden) { panel.style.removeProperty('--wiz-vh'); panel.style.removeProperty('--wiz-top'); return; }
    panel.style.setProperty('--wiz-vh', vv.height + 'px');
    panel.style.setProperty('--wiz-top', vv.offsetTop + 'px');
    log.scrollTop = log.scrollHeight;
  }
  function toggle(open) {
    panel.hidden = !open;
    document.body.classList.toggle('no-scroll', open && mq.matches);
    viewport();
    wiz.classList.toggle('is-open', open);
    opener.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open && !greeted) {
      greeted = true;
      say('<p>Hi! I can answer questions about ' + title + ' using its spec sheet — weight rating, sizes, what it suits, and how funding works.</p>');
      chips(STARTERS);
    }
    if (open) setTimeout(function () { input.focus(); }, 60); else opener.focus();
  }

  if (window.visualViewport) { window.visualViewport.addEventListener('resize', viewport); window.visualViewport.addEventListener('scroll', viewport); }
  opener.addEventListener('click', function () { toggle(panel.hidden); });
  wiz.querySelector('[data-wiz-close]').addEventListener('click', function () { toggle(false); });
  wiz.querySelector('[data-wiz-form]').addEventListener('submit', function (e) { e.preventDefault(); ask(input.value); input.value = ''; });
  wiz.addEventListener('click', function (e) { var c = e.target.closest('.wiz__chip'); if (c) ask(c.dataset.q); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !panel.hidden) toggle(false); });
})();
